export const ANNEX_LINK_ID_PREFIX = 'annexLink::';
export const CERTIFICATES_LIST_LINK_ID_PREFIX = 'certificatesListLink::';
